import React from "react";
import PlusComponent from "../../myComp/PlusComponent";
import PageGrid from "../../myComp/PageGrid";
import Loader from "../../myComp/Loader";

class CustomerGrid extends PlusComponent {
    constructor(props) {
      super(props, "customer");
   
      this.state = {
        grid: null,
      };  
    }
   
    componentDidMount() {
      this.getGrid();
    }
    
    updateGrid(){
      this.getGrid();
    }

    render(){     
        return (
          <div className="main-content">
            <Loader visible={this.state.loadPanelVisible}></Loader>   
            <PageGrid title="Elenco Clienti" data={this.state.grid} controller="customer" functionality="CUSTOMER" eventUpdate={this.updateGrid.bind(this)}></PageGrid>
          </div>
        );
    }     
}

export default CustomerGrid;